import React, { useState, useCallback } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import StepsBar from './components/StepsBar';
import ToastContainer from './components/Toast';
import Step1Process from './components/Step1Process';
import Step2PersonalData from './components/Step2PersonalData';
import Step3Requirements from './components/Step3Requirements';
import Step4Success from './components/Step4Success';

let toastId = 0;

export default function App() {
  const [step, setStep] = useState(1);
  const [processState, setProcessState] = useState({
    selectedProcessId: null,
    selectedDetailId: null,
    selectedProgramId: null,
    selectedCostId: null,
    processLabel: null,
    programLabel: null,
  });
  const [personalData, setPersonalData] = useState(null);
  const [applicationCode, setApplicationCode] = useState(null);
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((type, message) => {
    const id = ++toastId;
    setToasts((prev) => [...prev, { id, type, message }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const handleProcessUpdate = (update) => {
    setProcessState((prev) => ({ ...prev, ...update }));
  };

  const handleStep1Next = () => {
    if (processState.selectedProcessId && processState.selectedDetailId) setStep(2);
  };

  const handleStep2Next = (data) => {
    setPersonalData(data);
    setStep(3);
  };

  const handleSuccess = (code) => {
    setApplicationCode(code);
    setStep(4);
  };

  const handleReset = () => {
    setStep(1);
    setProcessState({ selectedProcessId: null, selectedDetailId: null, selectedProgramId: null, selectedCostId: null, processLabel: null, programLabel: null });
    setPersonalData(null);
    setApplicationCode(null);
    try { localStorage.removeItem('epg_form'); } catch {}
  };

  const formDataForSubmit = personalData
    ? {
        processId: processState.selectedProcessId,
        detailId: processState.selectedDetailId,
        programId: processState.selectedProgramId,
        costId: processState.selectedCostId,
        ...personalData,
      }
    : {};

  return (
    <div className="app">
      <Header />
      {step < 4 && <StepsBar currentStep={step} onBack={() => step > 1 && setStep(step - 1)} />}
      <main className="main">
        <div className="container">
          {step === 1 && (
            <Step1Process
              state={processState}
              onUpdate={handleProcessUpdate}
              onNext={handleStep1Next}
              addToast={addToast}
            />
          )}
          {step === 2 && (
            <Step2PersonalData
              onNext={handleStep2Next}
              onBack={() => setStep(1)}
              addToast={addToast}
            />
          )}
          {step === 3 && (
            <Step3Requirements
              programId={processState.selectedProgramId}
              formData={formDataForSubmit}
              onBack={() => setStep(2)}
              onSuccess={handleSuccess}
              addToast={addToast}
            />
          )}
          {step === 4 && (
            <Step4Success
              code={applicationCode}
              personalData={personalData}
              processState={processState}
              onReset={handleReset}
            />
          )}
        </div>
      </main>
      <Footer />
      <ToastContainer toasts={toasts} onRemove={removeToast} />
    </div>
  );
}
